import "./ProductSelection.scss";
import { ConvertVersion } from "../../KnxProductdata";
import { itx } from "../../translationItx/itx";
import { isUiModeExpert, uiModeWatcher } from "../../uiMode";
import { useOnChangeWatcher } from "../../models/useOnChangeWatcher";

/** Compact product information shown inside a selectable catalog tile. */
export function ProductCardText({ description, orderNumber, applicationVersion, variantEan }: {
  description: string;
  orderNumber: string;
  applicationVersion?: string;
  variantEan?: string;
}) {
  useOnChangeWatcher(uiModeWatcher);
  return (
    <>
      {description && <div className="catalog_productCardDescription">{description}</div>}
      <div title={itx("ui_KnxProductData.orderNumber", "Bestellnummer")}>{orderNumber}</div>
      {variantEan && <div>{itx("ServerTemplateList.EAN", "EAN")}: {variantEan}</div>}
      {isUiModeExpert() && applicationVersion && (
        <div>{itx("ui_KnxProductData.applicationVersion", "ProgramVersion")}: {ConvertVersion(applicationVersion)}</div>
      )}
    </>
  );
}
